import React, { useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import Overlay from "./../Utils/Overlay";
import { ReactComponent as CloseIcon } from "../../assets/images/cross.svg";

const PaymentIframe = ({
  url,
  close = () => { },
  setLoading = () => { },
  loading = null,
  onPaymentComplete = () => { },
  type = null,
}) => {
  const iframeRef = useRef(null);

  const onLoad = useCallback(() => {
    setLoading(false);
  }, [setLoading]);

  useEffect(() => {
    if (!url) return;

    const interval = setInterval(() => {
      try {
        const iframe = iframeRef.current;
        if (!iframe) return;
        const iframeUrl = iframe.contentWindow.location.href;
        if (iframeUrl && iframeUrl !== "about:blank" && !iframeUrl.includes("paymob")) {
          clearInterval(interval);
          close();
          if (
            iframeUrl.includes("success") ||
            iframeUrl.includes("complete") ||
            iframeUrl.includes("paid")
          ) {
            onPaymentComplete();
          }
          window.top.location.href = iframeUrl;
        }
      } catch (_) {
        // Cross-origin page — keep polling.
      }
    }, 500);

    return () => clearInterval(interval);
  }, [url, close, onPaymentComplete]);

  if (!url) return null;

  return ReactDOM.createPortal(
    <div className="payment-service-modal">
      {!loading && <Overlay darkTheme={true} handleOnClick={close} />}
      <div
        className={
          "popup payment-popup" +
          (loading ? " payment-popup--loading payment-iframe--loading" : "")
        }
        style={{ height: "80% !important" }}
        aria-hidden={loading ? true : undefined}
      >
        <CloseIcon className="popup__close" onClick={close} />
        <div className="popup__body" style={{ height: "100%", maxHeight: "100%" }}>
          <iframe
            allow="payment"
            ref={iframeRef}
            title="Payment"
            target="self"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"
            className={
              "payment-iframe" +
              (type === "paytabs" ? " payment-iframe--paytabs" : "")
            }
            id="frame"
            src={url.length === 0 ? "" : url}
            frameBorder="0"
            onLoad={onLoad}
            style={{ height: "100% !important" }}
          ></iframe>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default PaymentIframe;
